import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Employee } from '@app/models/employee/employee.model';
import { TimeTrackingResources } from '../time-tracking.resource';

@Injectable({
    providedIn: 'root',
})
@Injectable()
export class TimeTrackingPayrollEmployeeIntegrationService {
    constructor(private http: HttpClient) {}

    /**
     * batch assign and unassign employees to the payroll integration
     */
    async batch(attach: Employee[], detach: Employee[]): Promise<void> {
        const payload = {
            data: {
                type: 'timeTrackingPayrollEmployeeIntegrations',
                attributes: {
                    attach: attach.map((e) => ({ employeeId: e.id })),
                    detach: detach.map((e) => ({ employeeId: e.id })),
                },
            },
        };

        await this.http.post(TimeTrackingResources.AssignEmployeePayrollIntegration, payload).toPromise();
    }
}
